import React from "react";
import { PdfText } from "..";
import { View, StyleSheet, Link } from "@react-pdf/renderer";
import {
  backendSkills,
  frontendSkills,
  commonSkills,
} from "../../data/skillsData";
import { getFontSize } from "../../utils/getFontSize";
import { getWorkExp } from "../../utils/getWorkExp";
import { subsectionTitle } from "../../pdfStyles";
import {
  getDesiredRoleTitle,
  getDesiredRoleTitleTeckStack,
  titleFullname,
} from "../../consts/roles";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 38,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
  },
  headerColumn: {
    marginRight: 20,
  },
  about: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  aboutContainer: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
  },
  name: {
    fontSize: getFontSize(24),
    fontWeight: 700,
    marginBottom: 5,
  },
  jobTitle: {
    fontSize: getFontSize(18),
    marginBottom: 5,
  },
  descriptionContainer: {
    marginBottom: 10,
  },
  description: {
    textIndent: 10,
    textAlign: "left",
  },
  warning: {
    color: "hsl(349,100%,33%)",
  },
  subsectionTitle,
  skillsContainer: {
    height: 120,
    maxWidth: "95%",
    flexWrap: "wrap",
  },
  skill: {
    marginRight: 15,
  },
  titleRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  link: {
    marginBottom: 3,
  },
});

export const AboutSection = ({ desiredRole }) => {
  const desiredRoleTitle = getDesiredRoleTitle(desiredRole);
  const desiredRoleTitleTeckStack = getDesiredRoleTitleTeckStack(desiredRole);

  return (
    <View>
      <View style={styles.about}>
        <View style={styles.aboutContainer}>
          <View style={{ flexDirection: "row" }}>
            <View>
              <View style={styles.header}>
                <View style={styles.headerColumn}>
                  <PdfText style={styles.name}>{titleFullname}</PdfText>
                  <PdfText style={styles.jobTitle}>
                    {desiredRoleTitle} ({desiredRoleTitleTeckStack})
                  </PdfText>
                  <Link to="https://www.linkedin.com/in/alexander-piskun-react/">
                    <PdfText color="grey" style={styles.link}>
                      https://www.linkedin.com/in/alex-react-node/
                    </PdfText>
                  </Link>
                  <Link to="https://github.com/Sannnao">
                    <PdfText color="grey" style={styles.link}>
                      https://github.com/Sannnao
                    </PdfText>
                  </Link>
                </View>
                <View style={styles.headerColumn}>
                  <PdfText style={styles.link}>
                    ENG: <PdfText color="grey">C1</PdfText>
                  </PdfText>
                  <PdfText style={styles.link}>
                    PL: <PdfText color="grey">B2</PdfText>
                  </PdfText>
                  <PdfText style={styles.link}>
                    RU: <PdfText color="grey">C2</PdfText>
                  </PdfText>
                  <PdfText style={styles.link}>
                    Type of contract: <PdfText color="grey">B2B</PdfText>
                  </PdfText>
                </View>
                <View>
                  <PdfText color="grey" style={styles.link}>
                    Based in: Gdansk, Poland (Since 2021)
                  </PdfText>
                  <PdfText color="grey" style={styles.link}>
                    From: Belarus, Minsk
                  </PdfText>
                  <PdfText color="grey" style={styles.link}>
                    sannnao.developer@gmail.com
                  </PdfText>
                  <PdfText color="grey" style={styles.link}>
                    + (48) 573422511
                  </PdfText>
                </View>
              </View>
              <View style={{ flexDirection: "row" }}>
                <View style={styles.descriptionContainer}>
                  <PdfText style={styles.description}>
                    I'm a software engineer with over{" "}
                    <PdfText style={styles.warning}>{getWorkExp()}</PdfText> of
                    commercial experience in web development. Throughout my
                    career, I've gained hands-on experience in both front-end
                    and back-end development, independently delivering
                    full-stack solutions from initial requirements through
                    production deployment.
                  </PdfText>
                  <PdfText style={styles.description}>
                    I'm currently seeking opportunities to contribute as a{" "}
                    {desiredRoleTitle} on challenging projects involving AI,
                    React, Node.js, AWS. I bring a collaborative approach and
                    enthusiasm for learning new technologies.
                  </PdfText>
                </View>
              </View>
            </View>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View
              style={{
                marginRight: 10,
                borderRight: "1px dashed hsl(349,100%,33%)",
              }}
            >
              <PdfText style={styles.subsectionTitle}>Front-end skills</PdfText>

              <View style={styles.skillsContainer}>
                {frontendSkills.map((skill, i) => {
                  return (
                    <PdfText key={i} color="grey" style={styles.skill}>
                      {skill}
                    </PdfText>
                  );
                })}
              </View>
            </View>

            <View
              style={{
                marginRight: 10,
                borderRight: "1px dashed hsl(349,100%,33%)",
              }}
            >
              <PdfText style={styles.subsectionTitle}>Back-end skills</PdfText>

              <View style={styles.skillsContainer}>
                {backendSkills.map((skill, i) => {
                  return (
                    <PdfText key={i} color="grey" style={styles.skill}>
                      {skill}
                    </PdfText>
                  );
                })}
              </View>
            </View>

            <View style={{ marginLeft: 5 }}>
              <PdfText style={styles.subsectionTitle}>Common skills</PdfText>
              <View style={styles.skillsContainer}>
                {commonSkills.map((tool, i) => {
                  return (
                    <PdfText key={i} color="grey" style={styles.skill}>
                      {tool}
                    </PdfText>
                  );
                })}
              </View>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};
